// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Kmp0","socialActions":"_3Yxzl","buttonContainer":"_1O9T8","button":"XNzfY","buttonWrapper":"_1FBui","likeCount":"_1-QBy"};